module.exports = __webpack_public_path__ + "static/media/no_image.a41d7440.png";